export default class Share {
  constructor(url, text) {
    this.url = url;
    this.text = text;
  }
  get facebook() {
    return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`;
  }
  get twitter() {
    return `https://twitter.com/intent/tweet?text=${this.text}&url=${this.url}`;
  }
  get whatsapp() {
    return `https://api.whatsapp.com/send?text=${this.text}%20${this.url}`;
  }
  get copy() {
    return navigator.clipboard.writeText(decodeURIComponent(this.url));
  }
}
